import React from 'react';
import './FilterChips.css';
import { ActiveFilter, FILTER_FIELDS } from './types';

interface FilterChipsProps {
  filters: ActiveFilter[];
  onRemove: (id: string) => void;
}

export default function FilterChips({ filters, onRemove }: FilterChipsProps) {
  return (
    <div className="tc-chips-row">
      {filters.map(f => {
        const label = FILTER_FIELDS.find(fd => fd.key === f.field)?.label ?? f.field;
        return (
          <span key={f.id} className="tc-chip">
            <span className="tc-chip-text">{label} {f.operator} {f.value}</span>
            <button
              className="tc-chip-remove"
              onClick={() => onRemove(f.id)}
              aria-label="Remove filter"
            >
              ×
            </button>
          </span>
        );
      })}
    </div>
  );
}
